import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { API_CONFIG } from '../config/api.config';

/**
 * Interceptor que agrega el token de autenticación a todas las peticiones HTTP
 * o configura withCredentials si se usan cookies HTTP-only
 */
export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  // Si usamos cookies HTTP-only, solo agregamos withCredentials
  if (API_CONFIG.cookie_http_only) {
    const clonedReq = req.clone({
      withCredentials: true // Incluir cookies en la petición
    });
    return next(clonedReq);
  }

  // Si NO usamos cookies, agregamos el token manualmente
  return from(authService.getToken()).pipe(
    switchMap(token => {
      if (token) {
        const clonedReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        });
        return next(clonedReq);
      }
      
      return next(req);
    })
  );
};
